<template>
    <div>
        <tenderoffer :seeOfferVisible="seeOfferVisible" @showTenderStatus="showTenderStatus"></tenderoffer>
        <div class="my-tender" :class="loadingTextClass">
            <p class="title">报价明细</p>
            <div class="btn" v-if="openBtn">
                <div v-if="quoteType === TENDER_TYPE['BIDDING']">
                    <span v-has="'06010021'">
                        <el-button type="primary" class="operate-btn" @click="refreshFunc">刷新</el-button>
                    </span>
                    <span v-has="'06010021'">
                        <el-button type="primary" class="operate-btn" :loading="saveLoad" :disabled="overBidding" @click="seeFunc">报价</el-button>
                    </span>
                    <span v-has="'06010024'">
                        <el-button type="primary" class="operate-btn" :loading="exportLoad" @click="exportData">导出</el-button>
                    </span>
                </div>
                <div v-else>
                    <span v-has="'06010021'">
                        <el-button type="primary" class="operate-btn" :loading="saveLoad" :disabled="disabled" @click="saveData">保存</el-button>
                    </span>
                    <span v-has="'06010022'">
                        <el-button type="primary" class="operate-btn" :loading="pullLoad" :disabled="disabled" @click="submitData">提交</el-button>
                    </span>
                    <span v-has="'06010023'">
                        <m-import :disabled="disabled" :uploadUrl="uploadUrl" :maxSize="15" @successFunc="successFunc">
                            <span slot="button-name">导入</span>
                        </m-import>
                    </span>
                    <span v-has="'06010024'">
                        <el-button type="primary" class="operate-btn" :loading="exportLoad" @click="exportData">导出</el-button>
                    </span>
                </div>
            </div>
            <div class="btn" v-else>
                <span v-has="'06010024'">
                    <el-button type="primary" class="operate-btn" :loading="exportLoad" @click="exportData">导出</el-button>
                </span>
            </div>
            <div class="my-table">
                <vbtTable
                    ref="topicTable"
                    isBigData
                    height="600"
                    style="width: 100%"
                    border
                    :data="tableData"
                    v-loading="tableLoad"
                    element-loading-spinner="el-icon-loading"
                    :element-loading-text="loadingText"
                >
                    <template v-for="(item, index) in tableHeaders">
                        <vbt-table-column
                            :key="item.fieldColumnName"
                            :label="item.fieldName"
                            :prop="item.fieldColumnName"
                            :width="item.fieldName === '单价' ? '150' : index === tableHeaders.length - 1 ? '' : '100'"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <template v-if="index === 0 && !scope.row.quoteCodeParent">
                                    <span
                                        class="caret"
                                        :key="item.key"
                                        @click.stop="showDetail(scope.row)"
                                    >
                                        <i class="el-icon-caret-right" v-if="!scope.row.showSubTable"></i>
                                        <i class="el-icon-caret-bottom" v-else></i>
                                    </span>
                                </template>
                                <el-input-number
                                    v-if="item.fieldName === '单价' && scope.row.quoteCodeParent"
                                    v-model="scope.row.unitPrice"
                                    controls-position="right"
                                    :class="
                                        scope.row.unitPrice < 0 ||
                                        priceLen(scope.row.unitPrice)
                                            ? 'input-price input-error'
                                            : scope.row.relationLevel === null
                                            ? 'input-price-number input-price'
                                            : 'input-price'
                                    "
                                    :disabled="scope.row.relationLevel !== null"
                                    :step="1"
                                    :max="9999999999"
                                    @change="totalPrice(scope.row)"
                                    @focus="focusInput(scope.row, $event)"
                                ></el-input-number>
                                <span v-else>{{scope.row[item.fieldColumnName]}}</span>
                            </template>
                        </vbt-table-column>
                    </template>
                </vbtTable>
            </div>
            <OfferDailog
                :seeOfferVisible.sync="seeOfferVisible"
                :tenderCode="tenderCode"
                :bidNo="bidNo"
                :currentList="currentList"
                :currentTime="cuuntdownSeconds"
                :rankVisible="rankVisible"
            ></OfferDailog>
        </div>
    </div>
</template>
<script>
import tenderoffer from '../tenderNotice/Tenderoffer.vue';
import OfferDailog from './OfferDialog.vue';
import { getSupTmptDef, getDetailsParents, getDetailsSon, saveBidMsg, submitBidMsg, exportBidMsg, getImportBidTenderStatus } from '../../../api/tenderDetails.js';
// import config from '@/config/user.env';
import mImport from './Import.vue';
import { dictWithUrl } from '@/components/lots/api';
import { vbtTable, vbtTableColumn } from 'vbt-table';
import { TENDER_STATUS, BID_STATUS, TENDER_TYPE, LOWER_LAST_ROUND, BUSINESS_TYPE } from '../roundQuote/constant.js';
import { SRM_FILE_PRE } from '../../../constant/constant.js';

export default {
    name: 'myTender',
    data() {
        return {
            TENDER_STATUS,
            BID_STATUS,
            TENDER_TYPE,
            LOWER_LAST_ROUND,
            BUSINESS_TYPE,
            seeOfferVisible: false,
            tableLoad: false,
            saveLoad: false,
            pullLoad: false,
            exportLoad: false,
            isAllChecked: false,
            tableHeaders: [],
            tableData: [],
            bidName: '',
            bidNo: '',
            roundCurrent: '',
            rankVisible: '',
            tenderCode: '',
            supplierCode: '',
            tenderStatus: '',
            disabled: false,
            overBidding: false,
            currentTime: '',
            openBtn: true,
            uploadUrl: '',
            dictData: [],
            // focusIndex: '',
            // blurInput: '',
            currentInput: '', // 当前操作的input dom
            flagkey: false,
            quotePrecision: 0,
            notFocusFlag: '',
            quoteType: '',
            currentList: [],
            cuuntdownSeconds: 0,
            identificationCode: '', // 报价唯一码，登录防止串标
            intervalId: null,
            loadingText: '列表加载中',
            loadingTextClass: 'loadingTextColor',
        };
    },
    components: {
        tenderoffer,
        mImport,
        vbtTable,
        vbtTableColumn,
        OfferDailog
    },
    methods: {
        seeFunc() {
            this.seeOfferVisible = true;
        },
        priceLen(unitPrice) {
            if (!unitPrice) { return; }
            if (unitPrice.toString().split('.')[1] && unitPrice.toString().split('.')[1].length > this.quotePrecision) {
                return true;
            }
            return false;
        },
        getTableData() {
            this.tableLoad = true;
            // 获取表头
            getSupTmptDef({
                bidNo: this.bidNo,
                tenderCode: this.tenderCode,
                identificationCode: this.identificationCode
            }).then((res) => {
                if (res && res.code === '0') {
                    this.tableHeaders = res.data;
                }
            });
            const params = {
                supplierCode: this.supplierCode,
                tenderCode: this.tenderCode,
                identificationCode: this.identificationCode
            };
            // 获取表格数据
            getDetailsParents(params).then((res) => {
                if (res && +res.code === 0) {
                    this.tableData = this.formatParentsData(res.data);
                }
            }).finally(() => { this.tableLoad = false; });
            // // 获取表格数据
            // setTimeout(() => {
            //     const res = PARENTS_RES;
            //     if (res && +res.code === 0) {
            //         this.tableData = this.formatParentsData(res.data);
            //     }
            //     this.tableLoad = false;
            // }, 1000);
        },
        // forFucn(i) {
        //     for (let k = 0; k < this.tableData[i].children.length; k++) {
        //         if (
        //             this.tableData[i].children[k].unitPrice !== undefined &&
        //             this.tableData[i].children[k].unitPrice < 0
        //         ) {
        //             return 1;
        //         }
        //     }
        //     return 0;
        // },
        /** 保存 **/
        saveData() {
            const table = this.tableData.filter((item) => {
                return item.children;
            });
            // const dom = document.getElementsByClassName('input-error');
            // if (dom.length !== 0) {
            //     this.$message.error(
            //         `请先完善单价,小数位不能大于${this.quotePrecision}位,单价不能小于0`
            //     );
            //     return;
            // }
            if (this.currentTime === '已截止') {
                this.$message.warning('时间已结束，不能再报价!');
            } else {
                const par = [];
                table.forEach((el) => {
                    let obj = {
                        id: el.id,
                        unitPrice: el.unitPrice,
                        lineAmountTotal: el.lineAmountTotal
                    };
                    par.push(obj);
                    el.children.forEach((ele) => {
                        obj = {
                            id: ele.id,
                            unitPrice: ele.unitPrice,
                            lineAmountTotal: ele.lineAmountTotal
                        };
                        par.push(obj);
                    });
                });
                this.saveLoad = true;
                var params = {
                    tenderCode: this.tenderCode,
                    supplierCode: this.supplierCode
                };
                saveBidMsg(params, { bidDtlDetails: par, identificationCode: this.identificationCode }).then((res) => {
                    this.saveLoad = false;
                    if (res && +res.code === 0) {
                        this.getTableData();
                        this.$message.success('保存成功');
                    }
                });
            }
        },
        /** 提交 **/
        submitData() {
            // const dom = document.getElementsByClassName('input-error');
            // if (dom.length !== 0) {
            //     this.$message.error(
            //         `请先完善单价,小数位不能大于${this.quotePrecision}位,单价不能小于0`
            //     );
            //     return;
            // }
            this.$confirm('提交后将无法修改报价，请再次确认报价是否正确！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                var params = {
                    tenderCode: this.tenderCode,
                    supplierCode: this.supplierCode,
                    identificationCode: this.identificationCode
                };
                this.pullLoad = true;
                submitBidMsg(params).then((res) => {
                    if (res && res.code === '0') {
                        this.getTableData();
                        this.$message.success('提交成功');
                        this.disabled = true;
                    }
                }).catch(err => {}).finally(() => { this.pullLoad = false; });
            }).catch(() => {});
        },
        /** 导出 **/
        exportData() {
            this.exportLoad = true;
            exportBidMsg({ tenderCode: this.tenderCode, supplierCode: this.supplierCode, bidNo: this.bidNo, identificationCode: this.identificationCode }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data);
                    // const a = document.createElement('a');
                    // a.href = res.data.downUrl;
                    // a.download = res.data.localFileName;
                    // a.click();
                }
            }).finally(() => { this.exportLoad = false; });
        },
        showTenderStatus(data) {
            if (!data) {
                // 倒计时结束
                this.disabled = true;
                this.overBidding = true;
            } else {
                this.bidName = data.bidName;
                this.roundCurrent = data.roundCurrent;
                this.tenderStatus = data.tenderStatus;
                this.currentTime = data.currentTime;
                this.quotePrecision = data.quotePrecision;
                this.quoteType = data.quoteType;
                this.rankVisible = data.rankVisible || '';
                if (data.supplierTenderStatus === TENDER_STATUS['PUBILSH']) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
                if ((this.tenderStatus === TENDER_STATUS['PUBILSH'] && this.currentTime === '已截止') || this.currentTime === '已截止') {
                    this.disabled = true;
                }
                if (this.tenderStatus !== TENDER_STATUS['PUBILSH']) {
                    this.openBtn = false;
                }
                if (data.currentList) {
                    this.currentList = data.currentList;
                }
                if (data.cuuntdownSeconds) {
                    this.cuuntdownSeconds = data.cuuntdownSeconds;
                }
            }
        },
        // formatData(data) {
        //     data.map((item) => {
        //         item.shortlist = this.dictData.BID_WON_STATUS[item.shortlist];
        //         item.children.map((single) => {
        //             single.shortlist = this.dictData.BID_WON_STATUS[single.shortlist];
        //             single.unitPrice =
        //                 single.unitPrice !== null ?
        //                     single.unitPrice :
        //                     undefined;
        //         });
        //     });
        //     return data;
        // },
        // 转换父级数据格式
        formatParentsData(data) {
            data.forEach((item) => {
                item.shortlist = this.dictData.BID_WON_STATUS[item.shortlist];
                item.showSubTable = false;
            });
            return data;
        },
        // 转换子级数据格式
        formatSonData(data) {
            data.forEach((item) => {
                item.shortlist = this.dictData.BID_WON_STATUS[item.shortlist];
                item.unitPrice = item.unitPrice !== null ? item.unitPrice : undefined;
            });
            return data;
        },
        initFunc() {
            this.bidNo = this.$route.query.bidNo;
            this.supplierCode = this.$store.state.supplier.supplierCode;
            this.tenderCode = this.$route.query.tenderCode;
            this.uploadUrl =
                `${SRM_FILE_PRE}/bid/portal/importBidTenderSupplier/` +
                this.tenderCode +
                '/' +
                this.supplierCode +
                '?identificationCode=' + this.identificationCode;
            dictWithUrl(
                'BID_SU_TENDER_STATUS,BID_LOWER_LAST_ROUND,BID_YES_NO,BID_SU_TENDER_TYPE,BID_WON_STATUS'
            ).then((res) => {
                this.dictData = res.data;
                this.getTableData();
            });
            document.onkeydown = (e) => {
                this.flagkey = true;
                var key = window.event.keyCode;
                if (key === '13' * 1) {
                    this.notFocusFlag = true;
                    this.focusNextInput();
                    setTimeout(() => {
                        this.notFocusFlag = false;
                    }, '500');
                }
            };
        },
        successFunc() {
            this.loadingText = '当前正在导入中，请耐心等待...';
            this.loadingTextClass = 'loadingTextImportColor';
            this.tableLoad = true;
            this.disabled = true;
            // 设置定时器，每1秒轮询一次
            this.intervalId = setInterval(() => {
                this.circularFunction();
            }, 1000);
        },
        focusNextInput() {
            // 找出所有可输入的单价input dom输入框
            var inputs = document.querySelectorAll('.input-price-number > .el-input > input');
            // const dom = document.getElementsByClassName('input-price-number');
            // if (inputs[[...dom].indexOf(this.focusIndex) + 1] === undefined) {
            //     return;
            // }
            // inputs[[...dom].indexOf(this.focusIndex) + 1].focus();
            if (inputs[[...inputs].indexOf(this.currentInput) + 1] === undefined) {
                return;
            }
            inputs[[...inputs].indexOf(this.currentInput) + 1].focus();
        },
        focusInput(row, event) {
            // console.log(event);
            // Event.path 属于非标准 API，部分浏览器已删除该参数
            // this.focusIndex = event.path[2];
            this.currentInput = event.srcElement;
            event.srcElement.select();
            // this.blurInput = event.path[0];
        },
        showDetail(row, val) {
            const currentIndex = this.tableData.indexOf(row);
            row.showSubTable = !row.showSubTable;
            const dom = document.getElementsByClassName('input-error');
            if (dom.length !== 0) {
                this.$message.error('请先完善单价');
                return;
            }
            // 如果已经加载过了就直接取children的数据
            if (row.children && row.children.length) {
                this.setChildrenDataToTable(row.children, currentIndex);
                return;
            }
            const params = {
                supplierCode: this.supplierCode,
                tenderCode: this.tenderCode,
                quoteCode: row.quoteCode
            };
            this.tableLoad = true;
            getDetailsSon(params).then(res => {
                if (res && +res.code === 0) {
                    const childrenData = this.formatSonData(res.data);
                    this.tableData[currentIndex].children = childrenData;
                    // console.log('getDetailsSon', res);
                    this.setChildrenDataToTable(this.tableData[currentIndex].children, currentIndex);
                }
            }).finally(() => { this.tableLoad = false; });
            // this.tableLoad = true;
            // setTimeout(() => {
            //     const res = SON_RES;
            //     if (res && +res.code === 0) {
            //         row.showSubTable = !row.showSubTable;
            //         const childrenData = this.formatSonData(res.data);
            //         const index = this.tableData.indexOf(row);
            //         if (row.showSubTable) {
            //             // 展开
            //             this.tableData.splice(index + 1, 0, ...childrenData);
            //         } else {
            //             // 缩回
            //             this.tableData.splice(index + 1, childrenData.length);
            //         }
            //     }
            //     this.tableLoad = false;
            // }, 1000);
        },
        setChildrenDataToTable(data, index) {
            if (this.tableData[index].showSubTable) {
                // 展开
                this.tableData.splice(index + 1, 0, ...data);
            } else {
                // 缩回
                this.tableData.splice(index + 1, data.length);
            }
        },
        totalPrice(row) {
            var multiplyReg = RegExp(/\*/); // 关联公式是*乘积时
            var divideReg = RegExp(/\//); // 关联公式是/除法时
            // 判断是否有写入单价，且单价小数点后几位与是否大于 quotePrecision 的位数
            if (row.unitPrice && row.unitPrice.toString().split('.')[1] && row.unitPrice.toString().split('.')[1].length > this.quotePrecision) {
                this.$message.error(`小数位不能大于${this.quotePrecision}位`);
                return false;
            }
            // 当行未输入单价时总费用赋值0
            if (!row.unitPrice) {
                row.lineAmountTotal = 0;
            } else {
                // 当行有输入单价时，总费用=单价*预计业务量
                // 240912招标轮次报价总费用计费逻辑优化需求，要求与后端保持一致，总费用保留2位小数
                row.lineAmountTotal = (
                    row.unitPrice * row.expectTraffic
                ).toFixed(2);
            }
            // 找到该行子级的父级数据
            const table = this.tableData.filter((item) => {
                return item.quoteCode === row.quoteCodeParent;
            });
            table[0].lineAmountTotal = 0;
            table[0].children.forEach((item) => {
                // 找到与当前行同一个父级下其他有关联关系的子级数据
                if (item.relationLevel === row.bidLevel) {
                    if (row.unitPrice === undefined) {
                        item.unitPrice = undefined;
                        item.lineAmountTotal = 0;
                    } else if (row.unitPrice === 0) {
                        item.unitPrice = 0;
                        item.lineAmountTotal = 0;
                    } else {
                        // 其他子级数据根据 relationFormula 判断是乘法还是减法，都不是使用加法得到单价
                        if (multiplyReg.test(item.relationFormula)) {
                            const multiplyVal = item.relationFormula.slice(1);
                            item.unitPrice = (
                                row.unitPrice * multiplyVal
                            ).toFixed(this.quotePrecision);
                        } else if (divideReg.test(item.relationFormula)) {
                            const divideVal = item.relationFormula.slice(1);
                            item.unitPrice = (
                                row.unitPrice / divideVal
                            ).toFixed(this.quotePrecision);
                        } else {
                            item.unitPrice = (
                                row.unitPrice * 1 +
                                item.relationFormula * 1
                            ).toFixed(this.quotePrecision);
                        }
                        // 当前行总费用保留 2 位小数
                        item.lineAmountTotal = (
                            item.unitPrice * item.expectTraffic
                        ).toFixed(2);
                    }
                }
                // 父级总费用=子集总费用累加
                table[0].lineAmountTotal += item.lineAmountTotal * 1;
            });
            // 父级总费用保留 2 位小数
            table[0].lineAmountTotal = table[0].lineAmountTotal.toFixed(2);
        },
        scrollFn() {
            // if (this.blurInput) {
            //     this.blurInput.blur();
            // }
            if (this.currentInput) {
                this.currentInput.blur();
            }
        },
        refreshFunc() {
            this.initFunc();
        },
        circularFunction() {
            const params = {
                supplierCode: this.supplierCode,
                tenderCode: this.tenderCode
            };
            getImportBidTenderStatus(params).then(res => {
                if (res && +res.code === 0) {
                    if (res.data) {
                        const { status } = res.data;
                        // 0:未导入、1:导入中、2:导入完成、99:导入出错
                        if (status === '1') {
                            this.tableLoad = true;
                            this.disabled = true;
                        } else if (status === '2') {
                            this.$message.success('导入完成');
                            this.clearIntervalFunc();
                            this.initFunc();
                        } else if (status === '99') {
                            this.$message.warning('当前导入模版出现错误，请点击右上角文件信息中心下载报错文件查看具体错误原因');
                            this.clearIntervalFunc();
                        } else {
                            this.$message.warning('未导入成功');
                            this.clearIntervalFunc();
                        }
                    }
                }
            }).catch(() => {
                this.clearIntervalFunc();
            });
        },
        clearIntervalFunc() {
            this.tableLoad = false;
            this.disabled = false;
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.loadingText = '列表加载中';
                this.loadingTextClass = 'loadingTextColor';
                this.intervalId = null; // 确保下次调用stopPolling时不再尝试清除已不存在的定时器
            }
        }
    },
    mounted() {
        this.identificationCode = window.localStorage.getItem('bidIdentificationCode') || '';
        this.initFunc();
        this.$refs.topicTable.bodyWrapper.addEventListener(
            'scroll',
            this.scrollFn
        );
    },
    beforeDestroy() {
        this.$refs.topicTable.bodyWrapper.removeEventListener(
            'scroll',
            this.scrollFn
        );
        this.clearIntervalFunc();
    }
};
</script>
<style lang="less">
.my-tender {
    margin-right: 10px;
    &.loadingTextColor{
        .el-loading-text {
            color: #00BCBF !important;
        }
    }
    &.loadingTextImportColor{
        .el-loading-text {
            color: red !important;
        }
    }
    .title {
        float: left;
    }

    .btn {
        float: right;
        margin-top: 12px;

        .operate-btn {
            display: inline-block;
            margin-left: 10px;
            width: 56px;
            height: 28px;
            font-size: 12px;
            color: #fff;
            border: none;
            border-radius: 3px;
        }

        .demo-import {
            margin-left: 10px;
        }
    }

    .my-table {
        width: 100%;
        border-bottom: 1px solid #ebeef5;
        font-size: 14px;
        text-align: center;

        .input-price {
            width: 125px;
            height: 28px;
        }

        .input-error {
            .el-input__inner {
                border-color: red;
            }
        }
    }

    .cell {
        height: 28px;
    }

    .caret {
        cursor: pointer;
    }
}
</style>
